import { render, staticRenderFns } from "./AlarmUnreadList.vue?vue&type=template&id=b8263470&scoped=true&"
import script from "./AlarmUnreadList.vue?vue&type=script&lang=js&"
export * from "./AlarmUnreadList.vue?vue&type=script&lang=js&"
import style0 from "./AlarmUnreadList.vue?vue&type=style&index=0&id=b8263470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8263470",
  null
  
)

export default component.exports